import { createAsyncThunk } from '@reduxjs/toolkit'
import contractCourtService from 'services/contractCourts'

export const listContractCourts = createAsyncThunk(
  'contractCourts/list',
  contractCourtService.listContractCourts
)

export const getContractCourt = createAsyncThunk(
  'contractCourts/get',
  contractCourtService.getContractCourt
)

export const createContractCourt = createAsyncThunk(
  'contractCourts/create',
  contractCourtService.createContractCourt
)

export const cancelContractCourt = createAsyncThunk(
  'contractCourts/cancel',
  contractCourtService.cancelContractCourt
)

export const previewCancellation = createAsyncThunk(
  'contractCourts/preview-cancellation',
  contractCourtService.previewCancellation
)

export const previewShortening = createAsyncThunk(
  'contractCourts/preview-shortening',
  contractCourtService.previewShortening
)

export const updateEndDate = createAsyncThunk(
  'contractCourts/update-end-date',
  contractCourtService.updateEndDate
)
